<div>
  <div *ngIf="totalCount > maxCount" class="count_warning">
    <span>Flere enn {{maxCount}} resultater. Bruk søk for å begrense.</span>
  </div>
  <div *ngIf="showEmptyMessage" class="empty_message">
    {{emptyMessage}}
  </div>
  <mat-list class="list_container">
    <ng-content></ng-content>
  </mat-list>
</div>
